import { render, staticRenderFns } from "./TrendingGifts.vue?vue&type=template&id=308fc925&scoped=true"
import script from "./TrendingGifts.vue?vue&type=script&lang=js"
export * from "./TrendingGifts.vue?vue&type=script&lang=js"
import style0 from "./TrendingGifts.vue?vue&type=style&index=0&id=308fc925&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308fc925",
  null
  
)

export default component.exports